import React from 'react';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import styles from './styles.module.less';

const SortableHeader = ({ title, columnKey, sortState, onSort }) => {
  const isActive = sortState?.key === columnKey;
  const order = isActive ? sortState.order : null;

  const handleAsc = e => {
    e.stopPropagation();
    onSort(columnKey, 'asc');
  };

  const handleDesc = e => {
    e.stopPropagation();
    onSort(columnKey, 'desc');
  };

  return (
    <div className={styles.sortableHeader}>
      <span>{title}</span>
      <span className={styles.sortIcons}>
        <span
          role="button"
          tabIndex={0}
          className={classNames('material-icons-outlined', styles.sortIcon, {
            [styles.active]: order === 'asc',
          })}
          onClick={handleAsc}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleAsc(e);
            }
          }}
        >
          arrow_drop_up
        </span>
        <span
          role="button"
          tabIndex={0}
          className={classNames('material-icons-outlined', styles.sortIcon, {
            [styles.active]: order === 'desc',
          })}
          onClick={handleDesc}
          onKeyDown={e => {
            if (e.key === 'Enter' || e.key === ' ') {
              e.preventDefault();
              handleDesc(e);
            }
          }}
        >
          arrow_drop_down
        </span>
      </span>
    </div>
  );
};

SortableHeader.propTypes = {
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]).isRequired,
  columnKey: PropTypes.string.isRequired,
  sortState: PropTypes.shape({
    key: PropTypes.string,
    order: PropTypes.oneOf(['asc', 'desc']),
  }),
  onSort: PropTypes.func.isRequired,
};

export default SortableHeader;
